import { pb } from "./pocketbase";

/** Scope every protected query to the current authenticated identity. */
export function authCacheScope(): string {
  const id = pb.authStore.record?.id;
  return typeof id === "string" && id ? `user:${id}` : "anonymous";
}
